import React from 'react';

import { BetBlock } from '../../components/web';
import { BetBlockWrapper, WinPopUp } from '../../components/common';

export const WebMainWrapper = ({ children }) => {
  return (
    <div className='game-center-wr'>
      <div className='game-center-bottom'>
        <WinPopUp />
        <div className='game-center-bottom-ins'>
          <BetBlockWrapper innerComp={BetBlock} />
        </div>
      </div>
      {children}
    </div>
  );
};
